export default defineNuxtPlugin((nuxtApp) => {
  const { $site } = useNuxtApp()
  const { initialize } = useGtag()

  /* let dimension = 'site'

  if ($site.layout === 'bot') {
    dimension = 'bot'
  } else if ($site.layout === 'widget') {
    dimension = 'widget'
  } else if ($site.layout === 'facebook') {
    dimension = 'facebook'
  }

  const includes = []

  // Default Ovatu Tracking
  includes.push({
    id: 'G-B4H1X35WN0',
    params: {
      dimension1: dimension
    }
  }) */

  // Google analytics integration
  if ($site.integrations) {
    const integration = $site.integrations['1d8fbf495ebabf8c5cad1a8c2bf97662']
    const trackingID = integration && integration.data && integration.enabled ? integration.data.trackingID : null

    if (trackingID) {
      initialize(trackingID)
    }
  }
})